export const DISCOVER_PATH = "/discover";
export const INSIGHT_PATH = "/discover/insight";
